import React, { useState, useEffect } from 'react';
import { workflowSignin } from '../../lib/apiClient';
import GenericLoader from '../Common/Loader';
import store from '../../stores';

const Activepieces = (props) => {
  const [, setApRoute] = useState();
  const [loading, setLoading] = useState(true);
  const [loadingMessage, setLoadingMessage] = useState("Loading Workflow...");
  const [iFrameStyle,] = useState({
    width: '100%',
    height: '95%',
    border: 'none'
  });

  useEffect(() => {
    let route = '/runs';
    if(props.workflow && props.view === "builder"){
      setApRoute(`/flows/${props.workflow.environmentExternalWorkflowId}`);
      route = `/flows/${props.workflow.environmentExternalWorkflowId}`;
    }
    if(props.workflow && props.view === "runs"){
      setApRoute(`/runs`);
    }
    if(props.workflowExecution && props.view === "run"){
      setLoadingMessage("Loading Workflow Execution...");
      setApRoute(`/runs/${props.workflowExecution.run.runId}`);
      route = `/runs/${props.workflowExecution.run.runId}`;

    }

    embedSignin(route);
    // eslint-disable-next-line
  }, [props.workflow, props.workflowExecution]);

  const embedSignin = async function(finalRoute){    
    
    //if signinData is not set, we need to set it. 
      let routeChangeDispatched = false;
      const signinResult = await workflowSignin({accountSid: store.SessionStore.account.sid, environmentSid: store.SessionStore.environment.sid, bucketSid: store.SessionStore.bucket.sid});
      
      if(signinResult.successful){
        if (window.activepieces) {
          const configureData = {
            prefix: "/",
            instanceUrl: signinResult.data.baseUrl, // Replace with your actual instance URL
            jwtToken: signinResult.data.embedToken,
            embedding: {
              containerId: "activepiecesEmbed",
              builder: {
                disableNavigation: true,
                hideLogo: true,
                hideFlowName: true,
              },
              dashboard: {
                hideSidebar: true,
              },
              hideFolders: true,
              navigation: {
                handler: ({ route }) => {
                  console.log("Navigation route changed to:", route, routeChangeDispatched, finalRoute);
                  // Handle route change
                  if(route.endsWith("/flows") && !routeChangeDispatched){
                    routeChangeDispatched = true;
                    console.log('route again', finalRoute);
                    //window.activepieces.navigate({ route: `/flows/${props.workflow.environmentExternalWorkflowId}` });
                    window.activepieces.navigate({ route: finalRoute });
                  }else if(route === finalRoute){
                    setLoading(false);
                    console.log('Loaded...', loading);
                  }
                }
              }
            },
          };
  
          window.activepieces.configure(configureData);
          
        }

      }else{
        // some error...
        props.store.SessionStore.error({
          message:"There was an error loading the builder, please try again later.",
          onClear: () => {
            props.closeDrawer()
          }
        });
      }
  } 

  return (
    <>
      <div id="activepiecesEmbed" style={iFrameStyle} className={`${loading ? "hide" : ""}`}></div>
      {loading && <div style={iFrameStyle} className="d-flex justify-content-center align-items-center"><GenericLoader message={loadingMessage} /></div>}      
    </>
    
  );
}

export default Activepieces;